<template>
    <div>
        <div class="container-fluid mt-45">
            <div class="row">
                <div class="col-md-6">
                    <Breadcrumbs />
                </div>

                <div class="col-md-6 text-right">
                    <button @click="cancelTest()" class="btn btn-danger btn-cancel-test btn-block-mobile btn-lg lg-shadow mt-4 mt-md-0">Cancel test</button>
                </div>
            </div>
        </div>

        <div class="container mt-4">
            <div class="row justify-content-center">
                <div class="col-lg-5 col-md-8">
                    <div class="card border-0 shadow">
                        <div class="card-body py-5 px-55">
                            <h2>Is this the correct delivery address?</h2>

                            <div class="mt-4 text-sm">{{ formatAddress(patientAddress) }}</div>
                            <div v-if="patientPhone != null && patientPhone != ''" class="mt-4 text-sm">{{ patientPhone }}</div>
                            
                            <div class="mt-45">
                                <button @click="confirmDeliveryAddress()" class="btn btn-success btn-block btn-lg lg-shadow px-0">Yes</button>
                                
                                <button @click="enterDeliveryAddress()" class="btn btn-danger btn-block btn-lg lg-shadow mt-4 px-0">No</button>

                                <!-- Commented out while Collection Points are disabled -->
                                <!-- <router-link :to="{name: 'Location'}" class="btn btn-cancel btn-block btn-lg lg-shadow mt-4 px-0">Back</router-link> -->
                                <router-link :to="{name: 'TestDetails'}" class="btn btn-cancel btn-block btn-lg lg-shadow mt-4 px-0">Back</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Breadcrumbs from '@/partials/site-structure/BreadcrumbsComponent.vue'
import CancelTestModalComponent from '@/components/modals/CancelTestModalComponent.vue'
import FormatterMixin from '../../../Common/mixins/FormatterMixin'
export default {
    name: 'ConfirmDeliveryAddress',

    components: {
        Breadcrumbs
    },

    mixins: [
        FormatterMixin
    ],

    data() {
        return {
            CancelTestModalComponent
        }
    },

    mounted() {
        if(!this.patientName && !this.patientId && !this.patientTitle && this.patientAddress == '' && this.shippingAddressType !== 0) {
            return this.$router.push({name: 'Dashboard'})
        }
    },

    computed: {
        ...mapGetters({
            patientName: 'TestStore/GetPatientName',
            facilityId: 'TestStore/GetFacilityId',
            patientId: 'TestStore/GetPatientId',
            patientTitle: 'TestStore/GetPatientTitle',
            dueDate: 'TestStore/GetDueDate',
            reason: 'TestStore/GetReason',
            method: 'TestStore/GetMethod',
            deviceId: 'TestStore/GetDeviceId',
            patientAddress: 'TestStore/GetPatientAddress',
            patientPhone: 'TestStore/GetPatientPhone',
            shippingAddressType: 'TestStore/GetShippingAddressType'
        })
    },

    methods: {
        ...mapActions({
            setDeliveryAddressInTestStoreAction: 'TestStore/SetDeliveryAddress',
        }),

        async confirmDeliveryAddress() {
            await this.setDeliveryAddressInTestStoreAction(this.patientAddress)
            return this.$router.push({name: 'Confirmation'})
        },

        async enterDeliveryAddress() {
            await this.setDeliveryAddressInTestStoreAction(null)
            return this.$router.push({name: 'DeliveryAddress'})
        },

        cancelTest() {
            this.$modal.show(CancelTestModalComponent, {}, {width: '400px'});
        }
    }
}
</script>
